import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * ChangePasswordView class for handling password change functionality.
 */
export default class changePasswordView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Left section for new password input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'NewPassword',
                    type: 'password',
                    id: 'NewPassword',
                    label: _('Nueva Contraseña'), // Label for new password
                    labelPosition: 'top',
                    placeholder: _('Nueva Contraseña'), // Placeholder for new password
                    required: true,
                    invalidMessage: _(
                        'La contraseña debe contener mínimo 6 caracteres y un número, un carácter no se puede repetir más de 3 veces consecutivamente ',
                    ), // Validation message for new password
                    validate: function (password) {
                        // Custom validation for password strength
                        return password.length >= 6 && /[0-9]/.test(password) && !/(.)\1\1+/g.test(password);
                    },
                    on: {
                        onBlur: function () {
                            $$('NewPassword').validate(); // Validate on blur
                        },
                    },
                },
            ],
        };

        // Right section for confirm password input
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'ConfirmPassword',
                    type: 'password',
                    id: 'ConfirmPassword',
                    label: _('Confirmar Contraseña'), // Label for confirm password
                    labelPosition: 'top',
                    placeholder: _('Confirmar Contraseña'), // Placeholder for confirm password
                    required: true,
                    invalidMessage: _('Contraseñas no coinciden'), // Validation message for confirm password
                    validate: function (value) {
                        // Validation to check if confirm password matches new password
                        return value == $$('NewPassword').getValue();
                    },
                    on: {
                        onBlur: function () {
                            $$('ConfirmPassword').validate(); // Validate on blur
                        },
                    },
                },
            ],
        };

        // Upper section containing both password fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [center_left, right],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        // Clear form values and validation
                        $$('formChangePassword').setValues($$('formChangePassword').getCleanValues());
                        $$('formChangePassword').clearValidation();
                    },
                },
                {
                    view: 'button',
                    value: _('Guardar'), // Save button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newPassword = this.getRoot().getValues();
                            const cur_user = this.getParam('user', true);
                            if (newPassword.NewPassword === newPassword.ConfirmPassword) {
                                // Confirmation dialog before changing password
                                webix.confirm({
                                    type: 'confirm-warning',
                                    text: _('Advertencia!') + '<br/>' + _('Desea cambiar la contraseña?'),
                                    ok: _('Cambiar Contraseña'),
                                    cancel: _('Salir'),
                                    callback: function (action) {
                                        if (action === true) {
                                            const data = {
                                                FromId: cur_user,
                                                NewPassword: newPassword.NewPassword,
                                                ConfirmPassword: newPassword.ConfirmPassword,
                                            };
                                            // AJAX request to change password
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(devConfig.geturlApi() + 'betShop/ChangePassword', data, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            _('Error'), // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text);
                                                        if (json.HasError) {
                                                            if (json.CodeError != 110012) {
                                                                webix.message({
                                                                    text: json.AlertMessage,
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                });
                                                            }
                                                        } else {
                                                            webix.message({
                                                                text: _('Contraseña cambiada satisfactoriamente'), // Success message
                                                                title: _('¡Exito!'),
                                                                type: 'alert-warning',
                                                            });
                                                            $$('formChangePassword').setValues(
                                                                $$('formChangePassword').getCleanValues(),
                                                            );
                                                            $$('formChangePassword').clearValidation(); // Clear form after success
                                                        }
                                                    },
                                                });
                                        }
                                    },
                                });
                            } else {
                                webix.message({
                                    title: _('¡Error!'),
                                    type: 'alert-error',
                                    text: _('Contraseñas no coinciden'), // Error message for password mismatch
                                });
                            }
                        } else {
                            webix.message({
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: _('Completa los campos...'), // Error message for incomplete fields
                            });
                        }
                    },
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'formChangePassword',
            rows: [upper_section, buttons],
        };
    }
}

// FILE DOCUMENTED
